export type OurHomeLocation = {
  id: string;
  name: string;
  region: string;
  address: string;
  lat: number;
  lng: number;
};

export const OUR_HOME_LOCATIONS: OurHomeLocation[] = [
  {
    id: 'harpwood',
    name: 'Harpwood House',
    region: 'Kent',
    address: 'Harpwood House Limited, Seven Mile Lane, Wrotham Heath, Sevenoaks, Kent, TN15 7RY',
    lat: 51.297971890215564,
    lng: 0.345225693460603,
  },
  {
    id: 'rodwell',
    name: 'Rodwell House',
    region: 'Surrey',
    address: 'Rodwell House, Addlestone, Surrey, KT15 1HH',
    lat: 51.35673466845552,
    lng: -0.5145485740647904,
  },
  {
    id: 'harmonia-village',
    name: 'Harmonia Village',
    region: 'Kent',
    address: 'Harmonia Village, 42 Randolph Road, Dover, Kent, CT17 0FZ',
    lat: 51.13190215228467,
    lng: 1.2937220822366224,
  },
  {
    id: 'dover-house',
    name: 'Dover House',
    region: 'Kent',
    address: 'Dover House, 57 Coombe Valley Road, Dover, Kent, CT17 0EX',
    lat: 51.13296348713797,
    lng: 1.2944276719526826,
  },
  {
    id: 'whitstable-house',
    name: 'Whitstable House',
    region: 'Kent',
    address: 'Whitstable House, Boorman Way, Whitstable, CT5 3SE',
    lat: 51.34133484086814,
    lng: 1.0126344958176652,
  },
  {
    id: 'california-house',
    name: 'California House',
    region: 'Suffolk',
    address: 'California House, Ipswich, Suffolk',
    lat: 52.05697602585885,
    lng: 1.1848332106355965,
  },
];

export function getOurHomeLocation(id: string): OurHomeLocation | undefined {
  return OUR_HOME_LOCATIONS.find((home) => home.id === id);
}

export function googleMapsUrlForAddress(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}
